import React, { PureComponent } from 'react';
import {
  Card, Col, Button, ButtonToolbar,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { MDBDataTable } from 'mdbreact';
import API from '../../../Common/api';
import LoadingOverlay from 'react-loading-overlay';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DarkBackground from '../../../Common/backgroundLoader';
import Overlay from '../../../Common/overlay';
import DownloadIcon from '../../../../images/download_icon.svg';

const MAX_DATE_RANGE_DAYS = 14;

var url = window.location.hostname;
var port = window.location.port;

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.state = {
      loading_overlay: false,
      loading: false,
      showFetchBinData: false,
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false,
      toDateError: "",
      mdbTable: null,
    };
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }
  }

  formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  getDayDifference = (fromDate, toDate) =>
    (new Date(toDate) - new Date(fromDate)) / (1000 * 3600 * 24);

  exceedsMaxDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate) return false;
    return this.getDayDifference(fromDate, toDate) > MAX_DATE_RANGE_DAYS;
  };

  getToDateLimits = () => {
    const { from_date } = this.state;
    if (!from_date) return {};
    const minDate = new Date(from_date);
    const maxDate = new Date(from_date);
    maxDate.setDate(maxDate.getDate() + MAX_DATE_RANGE_DAYS);
    return { minDate, maxDate };
  };

  resetTableData = () => ({
    showFetchBinData: false,
    mdbTable: null,
  });

  FromDateChange = (date) => {
    const updates = {
      from_date: date,
      dateRangeError: false,
      showFromErr: false,
      ...this.resetTableData(),
    };

    if (!date) {
      this.setState({ ...updates, to_date: null });
      return;
    }

    const { to_date } = this.state;
    if (
      to_date &&
      (new Date(date) > new Date(to_date) ||
        this.exceedsMaxDateRange(date, to_date))
    ) {
      updates.to_date = null;
    }

    this.setState(updates);
  };

  ToDateChange = (date) => {
    const { from_date } = this.state;

    if (!date) {
      this.setState({
        to_date: null,
        dateRangeError: false,
        showToErr: false,
        ...this.resetTableData(),
      });
      return;
    }

    if (from_date) {
      const fromDate = new Date(from_date);
      const toDate = new Date(date);
      const dayDifference = this.getDayDifference(fromDate, toDate);

      if (fromDate > toDate) {
        this.setState({
          dateRangeError: true,
          to_date: null,
          toDateError: "To Date should be greater than From Date",
          ...this.resetTableData(),
        });
        return;
      }

      if (dayDifference > MAX_DATE_RANGE_DAYS) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null,
          ...this.resetTableData(),
        });
        return;
      }
    }

    this.setState({
      to_date: date,
      dateRangeError: false,
      showToErr: false,
      ...this.resetTableData(),
    });
  };

  buildTableData = (tileData) => {
    const columns =
      tileData.length > 0
        ? Object.keys(tileData[0]).map((k) => ({
          label: k,
          field: k,
          width: 220,
          sort: "disabled",
        }))
        : [];

    return { columns, rows: tileData };
  };

  fetchTilesdata = async () => {
    const { from_date, to_date } = this.state;

    if (!from_date) {
      this.setState({ showFromErr: true, showToErr: false });
      return;
    }
    if (!to_date) {
      this.setState({ showToErr: true, showFromErr: false });
      return;
    }
    if (this.state.dateRangeError || this.exceedsMaxDateRange(from_date, to_date)) {
      this.setState({
        dateRangeError: true,
        toDateError: "You cannot select more than 15 days",
      });
      return;
    }

    this.setState({
      loading: true,
      showFromErr: false,
      showToErr: false,
      showFetchBinData: false,
    });

    const payload = {
      from_date: this.formatDate(from_date),
      to_date: this.formatDate(to_date),
    };

    try {
      const { data } = await API.post(
        `/reports/staging-report/`,
        { param: payload }
      );

      const tileData = (data && data.data) ? data.data : (data || []);
      const mdbTable = this.buildTableData(tileData);

      this.setState({
        mdbTable,
        loading: false,
        showFetchBinData: true,
      });
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
    }
  };

  handleDownload = () => {
    const { mdbTable } = this.state;

    if (!mdbTable || !mdbTable.rows || mdbTable.rows.length === 0) {
      alert('No data available to download');
      return;
    }

    const headers = mdbTable.columns.map(col => col.label);
    let csvContent = headers.join(',') + '\n';

    mdbTable.rows.forEach(row => {
      const values = headers.map(header => {
        const value = row[header];
        if (value === null || value === undefined) {
          return '';
        }
        const stringValue = String(value);
        if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      });
      csvContent += values.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const blobUrl = URL.createObjectURL(blob);

    link.setAttribute('href', blobUrl);
    link.setAttribute('download', 'staging-report.csv');
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  };

  render() {
    const {
      loading,
      loading_overlay,
      loadingText,
      from_date,
      to_date,
      showFromErr,
      showToErr,
      dateRangeError,
      toDateError,
      showFetchBinData,
      mdbTable,
    } = this.state;

    return (
      <Col xl={12} style={{ margin: 0, padding: 0, height: '100%' }}>
        {loading_overlay && (
          <DarkBackground disappear={loading_overlay}>
            <LoadingOverlay
              active={loading_overlay}
              spinner={loading_overlay}
              text={loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            />
          </DarkBackground>
        )}
        <Card>
          <Overlay>
            <form className="form">
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>
              <div>
                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">From Date</span>
                  <div style={{ position: 'relative' }}>
                    <DatePicker
                      selected={from_date}
                      onChange={this.FromDateChange}
                      className="ledger_fromdate"
                      placeholderText="From Date"
                      dateFormat="yyyy-MM-dd"
                    />
                    <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }} />

                    {showFromErr && (
                      <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                    )}
                  </div>
                </div>

                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">To Date</span>
                  <div style={{ position: 'relative' }}>
                    <DatePicker
                      selected={to_date}
                      onChange={this.ToDateChange}
                      className="ledger_todate"
                      placeholderText="To Date"
                      dateFormat="yyyy-MM-dd"
                      {...this.getToDateLimits()}
                    />
                    <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }} />

                    {showToErr && (
                      <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                    )}
                    {dateRangeError && (
                      <span style={{ color: 'red', fontSize: 11 }}>{toDateError}</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1"
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    disabled={loading}
                    onClick={this.fetchTilesdata}
                  >
                    {loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>

                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                      backgroundColor: '#FFFFFF',
                      color: '#333333',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    id="button_download"
                    onClick={this.handleDownload}
                  >
                    <img
                      src={DownloadIcon}
                      alt="Download"
                      style={{ width: '22px' }}
                    />
                    Download
                  </Button>
                </ButtonToolbar>
              </div>
            </form>
          </Overlay>

          {showFetchBinData && mdbTable && (
            <div style={{ margin: 0, padding: 0, width: '100%' }}>
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: 0 }}
              >
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  scrollY
                  small
                  sortable={false}
                  hover
                  data={mdbTable}
                  style={{ textAlign: "left", margin: "0px", padding: "0px", paddingTop: "0px", width: '100%', height: '100%' }}
                />
              </div>
            </div>
          )}
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master',
})(withTranslation('common')(HorizontalForm));
